import { render, staticRenderFns } from "./course-card.vue?vue&type=template&id=60fb7840"
import script from "./course-card.ts?vue&type=script&lang=ts&external"
export * from "./course-card.ts?vue&type=script&lang=ts&external"
import style0 from "./course-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports